import { render } from "./ProfileButton.vue?vue&type=template&id=3556f7dc&scoped=true"
import script from "./ProfileButton.vue?vue&type=script&lang=js"
export * from "./ProfileButton.vue?vue&type=script&lang=js"

import "./ProfileButton.vue?vue&type=style&index=0&id=3556f7dc&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-3556f7dc"

export default script